import { render, staticRenderFns } from "./r-wonders-panel.vue?vue&type=template&id=58617bb2"
import script from "./r-wonders-panel.vue?vue&type=script&lang=js"
export * from "./r-wonders-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58617bb2')) {
      api.createRecord('58617bb2', component.options)
    } else {
      api.reload('58617bb2', component.options)
    }
    module.hot.accept("./r-wonders-panel.vue?vue&type=template&id=58617bb2", function () {
      api.rerender('58617bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/wonders/r-wonders-panel.vue"
export default component.exports